export const formatDomain = (domain) => {
  if (domain.length > 22) {
    const split = domain.split('.');
    const second = split[2] ? `.${split[2]}` : '';
    const dotDomain = `${split[0].substring(0, 22)}...[${split[1]}${second}]`;
    return dotDomain;
  }
  return domain;
};
